import { AuthService } from './http/auth.service';
import { FormGroup } from '@angular/forms/';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FuncionesService {

  constructor(
    private route: Router,
    private authSrv: AuthService
  ) { }

  generarvUser() : string {
    let abcMayus = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    let numeros = "1234567890"
    let simbolos = "!@#$%^&*_=+-.)"

    let contieneNumero = false, contieneMayus = false, contieneSimbolo = false

    let text = ""
    for (let i = 0; i < 8; i++) {
      if( !contieneMayus ) {
        text += abcMayus.charAt(Math.floor(Math.random() * abcMayus.length));
        contieneMayus = true;
      }else if( !contieneNumero ) {
        text += numeros.charAt(Math.floor(Math.random() * numeros.length));
        contieneNumero = true;
      }else if( !contieneSimbolo ) {
        text += simbolos.charAt(Math.floor(Math.random() * simbolos.length));
        contieneSimbolo = true;
      }else{
        text += abcMayus.toLowerCase().charAt(Math.floor(Math.random() * abcMayus.length));
      }
    }
    return text;
  }

  validarErrorSesion( error : HttpErrorResponse ) : string {
    let mensaje = "Lo sentimos, ocurrio un problema al resolver su solicitud @ " + error.status;
      if( error.status == 401 ) {
        mensaje = "Lo sentimos, ocurrio un problema al validar su solicitud."
      }
      if( error.status == 512 ) {
        mensaje = "Lo sentimos, su cuenta ha expirado."
      }
      if( error.status == 513 ) {
        mensaje = "Lo sentimos, sus credenciales han expirado."
      }
      if( error.status == 514 ) {
        mensaje = "Lo sentimos, su cuenta ha sido deshabilitada."
      }
      if( error.status == 515 ) {
        mensaje = "Lo sentimos, la cuenta no tiene ningun rol asignado."
      }
      if( error.status == 516 ) {
        mensaje = "Su usuario y/o contraseña son incorrectos."
      }
      if( error.status == 517 ) {
        mensaje = "Lo sentimos, su cuenta ha sido bloqueda."
      }
      if( error.status == 518 ) {
        mensaje = "Lo sentimos, ha ocurrido un problema al intentar iniciar sesión."
      }
      if( error.status == 500 || error.status == 0 ) {
        mensaje = "Lo sentimos, ha ocurrido un problema al intentar resolver su solicitud."
      }
      if( error.status == 519 ) {
        mensaje = "Lo sentimos, ha ocurrido un problema al intentar resolver su solicitud. Vuelve a intentar iniciar sesión en 3 minutos"
      }
      return mensaje
  }
  convertBytesToMB (bytes:number){
    return bytes * ( 9.5367431640625 * 10 ** -7 )}

  permiteEscritura() : boolean{
    let permiteEscritura = false;
    this.authSrv.getMenu().forEach((principal:any) => {
      let url = `/control${principal.path}`
      principal.secciones.forEach((seccion:any) => {
        if( `${url}${seccion.path}` == this.route.routerState.snapshot.url ) {
          permiteEscritura = seccion.escritura;
        }
      });
    });
    return permiteEscritura
  }

  permiteEscrituraV2() : boolean{
    let permiteEscritura = false;
    this.authSrv.getMenu().forEach((principal:any) => {
      let url = `/control${principal.path}`
      principal.secciones.forEach((seccion:any) => {
        if( this.route.routerState.snapshot.url.includes(`${url}${seccion.path}`)) {
          permiteEscritura = seccion.escritura;
        }
      });
    });
    return permiteEscritura
  }

  resetFormValidations( form: FormGroup, cleanForm: boolean = true ) {
    Object.keys(form.controls).forEach((key) => {
      const control = form.controls[key];
      if( cleanForm ) {
        control.reset()
      }
      control.setErrors(null)
      control.markAsPristine();
      control.markAsUntouched();
    });
  }
}
